// @flow weak

import PropTypes from 'prop-types';
import React from 'react';
import bemify from 'bemify-js';

import Progress from 'app/common/components/Progress';
import partiallyApplyComponent from 'app/common/components/partiallyApplyComponent';
import 'app/common/components/ProgressBar.scss';

const ProgressBar = props => {
  const bem = bemify('progress-bar-v2');
  const percent = 100 * props.decimal;
  const width = `${percent}%`;
  const className = bem(`--${props.type}`, props.className);
  return (
    <div className={className}>
      <div
        className={bem('__amount')}
        style={{ width }}
        title={props.formattedPercent}
      />
    </div>
  );
};

ProgressBar.propTypes = {
  decimal: PropTypes.number.isRequired,
  formattedPercent: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default partiallyApplyComponent(Progress, { Renderer: ProgressBar });
